import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import { NgClass } from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'pub-json-input',
  templateUrl: './json-input.component.html',
  styleUrls: ['./json-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonInputComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [MatFormField, MatLabel, MatInput, NgClass, MatTooltip]
})
export class JsonInputComponent implements ControlValueAccessor {
  @Input() hasError = false;
  @Input() errorMessage: string = 'Invalid JSON format';
  @Input() label: string = '';
  @Input() tooltip: string = '';

  value: string = '';

  onChange: any = () => {
  };

  onTouched: any = () => {
  };

  onInputChange(event: Event): void {
    this.value = (event.target as HTMLTextAreaElement).value;
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value === null || value === undefined) {
      this.value = '';
    } else if (typeof value === 'object') {
      try {
        this.value = JSON.stringify(value, null, 2);
      } catch {
        this.value = '';
      }
    } else {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
